/**
 * @generated SignedSource<<c49943781b7b8eb5b8ca7912dd4a3e1d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutVatReverseChargeCheckbox_transaction$data = {
  readonly canBeVatReverseCharge: boolean | null;
  readonly reviews: ReadonlyArray<{
    readonly status: string | null;
    readonly type: string | null;
  } | null> | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "CheckoutVatReverseChargeCheckbox_transaction";
};
export type CheckoutVatReverseChargeCheckbox_transaction$key = {
  readonly " $data"?: CheckoutVatReverseChargeCheckbox_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutVatReverseChargeCheckbox_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutVatReverseChargeCheckbox_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canBeVatReverseCharge",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TransactionReview",
      "kind": "LinkedField",
      "name": "reviews",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "17f26e077ed9836ee68e4027bec704ee";

export default node;
